import React, { useEffect, useState } from "react";
import "./index.css";
import { useLoad } from "../../context/Load";
import { useNavigate } from "react-router";
import ApiServices from "../../services/apiServices";
import voltar from "../../assets/images/png/voltar.png";
import Mask from "../../services/mask";
import { Link } from "react-router-dom";
import storage from "../../services/storage";
import { toast } from "react-toastify";

export default function CelularVerificacao() {
  const { load, setLoad } = useLoad();
  const [celularVerificacao, setCelularVerificacao] = useState("");
  const [tempo, setTempo] = useState(120);

  const navigate = useNavigate();
  async function fnReenviarCodigo() {
    var obj = {
      userName: storage.get("USUARIO")?.userName,
      email: storage.get("USUARIO")?.email,
      celular: storage.get("USUARIO")?.phoneNumber,
    };
    try {
      setLoad(true);
      let response = await ApiServices.apiPost(
        "duplo-fator/deslogado/enviar/sms",
        obj
      );
      const data = await response.json();
      if (data.statusCode === 200) {
        toast.success(data.data);
        setTempo(120);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnCodigo(id) {
    var obj = {
      userName: storage.get("USUARIO")?.userName,
      email: storage.get("USUARIO")?.email,
      codigoDuploFator: id,
    };
    try {
      setLoad(true);
      let response = await ApiServices.apiPost("usuario/sms/confirmar", obj);
      const data = await response.json();
      if (data.statusCode === 200) {
        const atualizado = Object.assign(storage.get("USUARIO"), data.data);
        storage.set("USUARIO", atualizado);
        toast.success(data.data);
        navigate("/celular-verificado");
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  function fnInserirNumero(e) {
    if (e.target.value === "" && e.target.previousElementSibling !== null) {
      e.target.previousElementSibling.focus();
    } else {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    }

    if (
      e.target.value !== "" &&
      e.target.nextElementSibling &&
      e.target.nextElementSibling.nodeName === "INPUT"
    ) {
      e.target.nextElementSibling.focus();
    }

    var i1 =
      document.querySelectorAll(".celularVerificacaoInputCard")[0].value || "";
    var i2 =
      document.querySelectorAll(".celularVerificacaoInputCard")[1].value || "";
    var i3 =
      document.querySelectorAll(".celularVerificacaoInputCard")[2].value || "";
    var i4 =
      document.querySelectorAll(".celularVerificacaoInputCard")[3].value || "";
    var i5 =
      document.querySelectorAll(".celularVerificacaoInputCard")[4].value || "";
    var i6 =
      document.querySelectorAll(".celularVerificacaoInputCard")[5].value || "";
    var todosI = i1 + i2 + i3 + i4 + i5 + i6;
    if (todosI.length === 6) {
      fnCodigo(todosI);
    }
  }

  function fnColarNumero(ev) {
    let paste = ev.clipboardData.getData("text");
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (tempo > 0) {
        setTempo(tempo - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [tempo]);
  return (
    <>
      <div className="imgBackground"></div>
      <div className="d-flex justify-content-center">
        <div style={{ maxWidth: 500 }}>
          <div className="px-5">
            <Link onClick={() => window.history.back()}>
              <img className="imgVoltar" src={voltar} alt="" />
            </Link>
            <div className="celularVerificacaoTexto1">Verificação</div>
            <div className="celularVerificacaoTexto2">
              Digite o código que enviamos por SMS
            </div>

            <div className="d-flex justify-content-center celularVerificacaoInputCardTodos ">
              <input
                className="celularVerificacaoInputCard"
                type="text"
                maxLength="1"
                name="digit1"
                onChange={fnInserirNumero}
                onPaste={fnColarNumero}
                inputMode="numeric"
              />
              <input
                className="celularVerificacaoInputCard"
                type="text"
                maxLength="1"
                name="digit2"
                onChange={fnInserirNumero}
                onPaste={fnColarNumero}
                inputMode="numeric"
              />
              <input
                className="celularVerificacaoInputCard"
                type="text"
                maxLength="1"
                name="digit3"
                onChange={fnInserirNumero}
                onPaste={fnColarNumero}
                inputMode="numeric"
              />
              <input
                className="celularVerificacaoInputCard"
                type="text"
                maxLength="1"
                name="digit4"
                onChange={fnInserirNumero}
                onPaste={fnColarNumero}
                inputMode="numeric"
              />
              <input
                className="celularVerificacaoInputCard"
                type="text"
                maxLength="1"
                name="digit5"
                onChange={fnInserirNumero}
                onPaste={fnColarNumero}
                inputMode="numeric"
              />
              <input
                className="celularVerificacaoInputCard"
                type="text"
                maxLength="1"
                name="digit6"
                onChange={fnInserirNumero}
                onPaste={fnColarNumero}
                inputMode="numeric"
              />
            </div>

            <div className="celularVerificacaoTexto3">
              Aguarde <b>{tempo} segundos </b>
              para reenviar o código SMS
            </div>
            <br />
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-secondary "
                disabled={tempo !== 0}
                onClick={() => {
                  fnReenviarCodigo();
                }}
              >
                Reenviar o código
              </button>
            </div>
            <br />
            <div className="celularVerificacaoTexto4">
              Nunca pedimos este dado por e-mail, SMS ou telefone. Não
              compartilhe este código com ninguém.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
